var _circle, _path, _rect, _rect2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApAgingDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 21h15.759a3 3 0 0 1 1.937.71l9.527 8.058A3 3 0 0 1 54 32.058v25.109c0 3.58-.04 3.833-3.714 3.833H25.714C22.041 61 22 60.748 22 57.167V24.833c0-3.58.04-3.833 3.714-3.833Z",
    fill: "#006C52"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 39,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#A0C9BF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 10,
    height: 4,
    rx: 2,
    fill: "#A0C9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.417 65.833c6.305 0 11.416-5.111 11.416-11.416C63.833 48.11 58.722 43 52.417 43 46.11 43 41 48.111 41 54.417c0 6.305 5.111 11.416 11.417 11.416Z",
    fill: "#A0C9BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7 49.85a2.283 2.283 0 1 0-4.567 0v4.567c0 .605.241 1.186.67 1.614l2.283 2.284a2.283 2.283 0 0 0 3.229-3.23L54.7 53.471V49.85Z",
    fill: "#006C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApAgingDetail);
export default __webpack_public_path__ + "static/media/ap-aging-detail.6122d2f3.svg";
export { ForwardRef as ReactComponent };